import React from 'react';
import EImg from './EImg';

const EStar = ({ width = 24, height = 24 }) => (
	<EImg
		width={width}
		height={height}
		title="RECOMMENDED"
		aria-label="Emoji: Glowing star"
		alt="🌟"
		src="https://abs.twimg.com/emoji/v2/72x72/1f31f.png"
	/>
);

export default EStar;
